import type { Testimonial } from '../types/testimonials';

export const TESTIMONIALS_1: Testimonial[] = [
  {
    authorAvatar: '/images/testimonials/pedro.webp',
    authorName: 'Pedro Rodrigues',
    authorTagline: 'Product Manager | Product Owner CSPO®',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'I had the pleasure of working with Victor as a fullstack developer. His technical skills and commitment to excellence are remarkable.',
  },
  {
    authorAvatar: '/images/testimonials/marcela.webp',
    authorName: 'Marcela De Mingo',
    authorTagline: 'Copywriting | UX Writing | Web Content Writing',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      "Victor is extremely optimistic, professional and open-minded about learning new skills. It's a pleasure to have worked beside him!",
  },
  {
    authorAvatar: '/images/testimonials/kayo.webp',
    authorName: 'Kayo Elias Gonçalves Verdan',
    authorTagline: 'Full-Stack Developer - ReactJS | TypeScript | NextJS',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'Victor is an incredible person to work with, focused and always willing to help everyone. He dedicates 100% to everything he does.',
  },
  {
    authorAvatar: '/images/testimonials/roberto.webp',
    authorName: 'Roberto Rabelo',
    authorTagline: 'Software development C# | .NET | Angular',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'He has always stood out for his proactivity, curiosity, and great desire to learn. Clearly self-taught, always seeking new knowledge. An excellent professional.',
  },
  {
    authorAvatar: '/images/testimonials/larissa.webp',
    authorName: 'Larissa Mendes',
    authorTagline: 'Frontend Developer | React.js | Vue.js | TypeScript',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'Victor is an excellent professional, very dedicated and always ready to help his colleagues!',
  },
];

export const TESTIMONIALS_2: Testimonial[] = [
  {
    authorAvatar: '/images/testimonials/lucas.webp',
    authorName: 'Lucas Mugnaini',
    authorTagline: 'Project Manager | Product Manager | Agile Master',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'Victor has huge potential, his commitment and dedication are valuable qualities.',
  },
  {
    authorAvatar: '/images/testimonials/matheus.webp',
    authorName: 'Matheus Almeida',
    authorTagline: 'Frontend Software Engineer | React Specialist',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'Great working with you, always focused and engaged to help the team and collaborate for project success!',
  },
  {
    authorAvatar: '/images/testimonials/roberta.webp',
    authorName: 'Roberta Correia',
    authorTagline: 'Product Owner',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'Professional committed to deadlines, executes activities efficiently. Very concerned about the team and delivery.',
  },
  {
    authorAvatar: '/images/testimonials/romulo.webp',
    authorName: 'Romulo Brandão',
    authorTagline:
      'Full Stack Developer | Python | Generative AI | Data Science',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'Excellent professional, very proactive and dedicated to projects. Creative since school days.',
  },
  {
    authorAvatar: '/images/testimonials/hugo.webp',
    authorName: 'Hugo Barreto Ferreira',
    authorTagline: 'Senior Systems Analyst | Backend | Java | Spring Boot',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'I recommend this high-quality professional, focused on problem-solving, excellent communication with team and clients.',
  },
  {
    authorAvatar: '/images/testimonials/fernanda.webp',
    authorName: 'Fernanda Cataldo',
    authorTagline: 'Creation | Strategy | Content Marketing | Social Media',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'Victor is an excellent professional to work with in a team, very helpful, agile and always seeking the right solution. A great friend and mentor.',
  },
  {
    authorAvatar: '/images/testimonials/yan.webp',
    authorName: 'Yan Felipy',
    authorTagline: 'Full-Stack Developer | React | JavaScript | Node',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'Victor has always been a great friend and a professional with a big heart. He helped me start my DEV career, always motivating.',
  },
  {
    authorAvatar: '/images/testimonials/karol.webp',
    authorName: 'Ana Karoline Hoth',
    authorTagline: 'Biotechnologist | Zootechnician | Animal Production',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'Wonderful professional! Proactive, extremely helpful and executes great teamwork.',
  },
  {
    authorAvatar: '/images/testimonials/rafael.webp',
    authorName: 'Rafael Carvalho',
    authorTagline: 'Tech Lead | PHP | Node | WordPress | React Native | React',
    url: 'https://www.linkedin.com/in/victorsaisse/details/recommendations/',
    quote:
      'Excellent professional, great at teamwork, quick learner, and fast evolution. I definitely recommend.',
  },
];
